(() => {
  const updateInfoBarHeight = () => {
    const infoBar = document.querySelector('[data-info-bar]');
    document.documentElement.style.setProperty('--info-bar-height', `${infoBar?.offsetHeight || 0}px`);
  };

  const initNewsletterModals = (scope = document) => {
    scope.querySelectorAll('[data-newsletter-modal]').forEach((modal) => {
      if (modal.dataset.newsletterInitialized === 'true') return;
      modal.dataset.newsletterInitialized = 'true';

      const dialog = modal.querySelector('[data-newsletter-dialog]');
      const title = modal.querySelector('[data-newsletter-title]');
      const successContent = modal.querySelector('[data-newsletter-success]');
      const formFields = modal.querySelector('[data-newsletter-form-fields]');
      const sectionWrapper = modal.closest('.info-bar-section');
      const triggers = Array.from(document.querySelectorAll('[data-newsletter-open]')).filter(
        (trigger) => trigger.getAttribute('aria-controls') === modal.id,
      );
      const closeButtons = modal.querySelectorAll('[data-newsletter-close]');
      let lastFocusedElement = null;
      let closeTimer = null;

      const clearSuccessUrl = () => {
        if (!modal.hasAttribute('data-newsletter-success-state')) return;

        const url = new URL(window.location.href);
        const removableParameters = ['customer_posted', 'contact_posted'];
        let hasChanged = false;

        removableParameters.forEach((parameter) => {
          if (!url.searchParams.has(parameter)) return;
          url.searchParams.delete(parameter);
          hasChanged = true;
        });

        if (url.hash === '#contact_form' || url.hash === `#${modal.closest('form')?.id}`) {
          url.hash = '';
          hasChanged = true;
        }

        if (hasChanged) {
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
      };

      const resetSuccessState = () => {
        if (!modal.hasAttribute('data-newsletter-success-state')) return;

        modal.removeAttribute('data-newsletter-success-state');
        modal.removeAttribute('data-open-on-load');
        if (successContent) successContent.hidden = true;
        if (formFields) formFields.hidden = false;
        if (title?.dataset.formTitle) title.textContent = title.dataset.formTitle;
      };

      const getFocusableElements = () =>
        Array.from(
          modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ),
        ).filter((element) => !element.hidden && element.offsetParent !== null);

      const openModal = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        sectionWrapper?.classList.add('info-bar-section--modal-open');
        document.body.classList.add('info-bar-newsletter-modal-open');
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));

        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const emailInput = modal.querySelector('input[type="email"]');
          (emailInput || dialog)?.focus({ preventScroll: true });
        });
      };

      const closeModal = (restoreFocus = true) => {
        modal.classList.remove('is-open');
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        document.body.classList.remove('info-bar-newsletter-modal-open');

        closeTimer = window.setTimeout(() => {
          modal.hidden = true;
          sectionWrapper?.classList.remove('info-bar-section--modal-open');
          resetSuccessState();
          closeTimer = null;
        }, 220);

        if (restoreFocus && lastFocusedElement instanceof HTMLElement) {
          lastFocusedElement.focus({ preventScroll: true });
        }
      };

      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', openModal);
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => closeModal());
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        if (!focusableElements.length) {
          event.preventDefault();
          dialog?.focus();
          return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      });

      if (modal.hasAttribute('data-open-on-load')) {
        clearSuccessUrl();
        window.setTimeout(openModal, 0);
      }
    });
  };

  const initializeInfoBar = () => {
    updateInfoBarHeight();
    initNewsletterModals();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeInfoBar, { once: true });
  } else {
    initializeInfoBar();
  }

  window.addEventListener('resize', updateInfoBarHeight);
  document.addEventListener('shopify:section:load', (event) => {
    updateInfoBarHeight();
    initNewsletterModals(event.target);
  });
})();
